import { UnitType } from './models/unit-type';
import OrderService from '../services/order.service';

export default {
  namespaced: true,
  state: {
  },
  actions: {
    init({ dispatch }) {
      dispatch('getUnitTypes');
    },
    getUnitTypes() {
      OrderService.getUnitTypes()
        .then((types) => UnitType.create({ data: types }));
    },
  },
  getters: {
    unitTypes() {
      return UnitType.all();
    },
    orderUnitTypes() {
      return UnitType.all()
        .filter((type) => type.code !== 'mt');
    },
  },
};
